export default {
  styleOverrides: {
    tooltip: ({ ownerState, theme }) => ({
      border: "1px solid",
      borderRadius: "4px",
      padding: "5px 10px",
      boxShadow: "0px 3px 9px 0px rgba(183, 183, 183, 0.10)",
      ...(ownerState.variant === "white" && {
        backgroundColor: theme.palette.white.main,
        borderColor: theme.palette.grey250.main,
      }),
      ...(ownerState.variant === "blue" && {
        backgroundColor: theme.palette.blue50.main,
        borderColor: "rgba(24, 140, 229, 0.25)", // custom color, not in theme
      }),
      ...(ownerState.variant === "black" && {
        backgroundColor: theme.palette.grey600.main,
        borderColor: theme.palette.grey600.main,
      }),
      ...(ownerState.variant === "red" && {
        backgroundColor: theme.palette.red400.main,
        borderColor: theme.palette.red400.main,
      }),
    }),
    arrow: ({ ownerState, theme }) => ({
      "&:before": {
        border: "1px solid",
        boxShadow: "0px 3px 9px 0px rgba(183, 183, 183, 0.10)",
        ...(ownerState.variant === "white" && {
          backgroundColor: theme.palette.white.main,
          borderColor: theme.palette.grey250.main,
        }),
        ...(ownerState.variant === "blue" && {
          backgroundColor: theme.palette.blue50.main,
          borderColor: "rgba(24, 140, 229, 0.25)",
        }),
        ...(ownerState.variant === "black" && {
          backgroundColor: theme.palette.grey600.main,
          borderColor: theme.palette.grey600.main,
        }),
        ...(ownerState.variant === "red" && {
          backgroundColor: theme.palette.red400.main,
          borderColor: theme.palette.red400.main,
        }),
      },
    }),
  },
};
